import { useState, useEffect, Fragment } from "react";
// import cardArrow from "../../assets/images/icons/bo-arrow.svg";
// import addclienticon from "../../assets/images/icons/add-client.svg";
import DonutChart from "../../helpers/DonutChart";
import AddClient from "./AddClient";
import SearchGridClient from "./SearchGridClients";
import { Env } from "../../enviroment/environment";
import clientmanagmentObj from "../../services/client-managment.service";
import BoLoader from "../../helpers/BoLoader";
import RefreshToken from "../../helpers/RefreshToken";
import { Link } from "react-router-dom";
import { history } from "../../helpers/history";
import ModelPopup from "../../helpers/ModelPopup";
import TransferClient from "./TransferClient";
import { useDispatch, useSelector } from "react-redux";
import { haspermissions } from "../permissions/PermissionTypes";
import AddSuperClient from "../superclient/AddSuperClient";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import transactionObj from "../../services/transaction.service";
import GetAllClients from "../../helpers/GetAllClients";
import ExportToExcel from "./ExportToExcel";
const API_URL = Env.ClientAdmin;
const SearchGridInputData = [
  {
    Name: "",
    TokenId: "",
    IssueDate: "",
    ExpiryDate: "",
    DateFrom: "",
    DateTo: "",
    CardNumber: "",
    startIndex: 1,
    scrolled: false,
    isFirstTime: true,
    SearchClearClicked: false,
    ClientId: "",
    IssuerType: "",
  },
];
const Clients = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [ShowClietErr, setShowClientErr] = useState("d-none");
  const [confirmmodalShow, setCnfrmModalShow] = useState(false);
  const [Content, setContent] = useState();
  const [DataSuccessful, setDataSuccessful] = useState(false);
  const [boloader, setBoLoader] = useState(false);
  const [donutChart, setDonutChart] = useState();
  const [modalsuccessfullShow, setModalsuccessfullShow] = useState(false);
  const [modalShowTransferClient, setModalShowTransferClient] = useState(false);
  const [modelconfirmsuperclient, setModelconfirmsuperclient] = useState(false);
  const [client, setClient] = useState("");

  const [isExcelDownload, setiisExcelDownload] = useState(false);
  const [showExcelDownloadModal, setshowExcelDownloadModal] = useState(false);
  const [showIssuerBalances, setShowIssuerBalances] = useState(false);
  const [IssuerXCardBalances, setIssuerXCardBalances] = useState(false);
  const [dataset, setDataset] = useState();
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  if (currentUser) {
    haspermissions.CreateClient =
      currentUser?.user?.Permissions?.includes("Create Client");
    haspermissions.LedgerTransfer =
      currentUser?.user?.Permissions?.includes("Ledger Transfer");
  }

  useEffect(() => {
    getCountDashboard();
  }, []);

  const getCountDashboard = () => {
    setBoLoader(true);
    setDataSuccessful(false);
    clientmanagmentObj.getclientcount().then(
      (response) => {
        setContent(response.data.payload.result);
        const lst_donutchart = {
          Active: response.data.payload.result.activeClient,
          Suspended: response.data.payload.result.inActiveClient,
        };
        setDonutChart(lst_donutchart);
        setDataSuccessful(true);
        setBoLoader(false);
      },
      (error) => {
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            window.location.reload();
            setBoLoader(false);
          } else {
            setBoLoader(false);
          }
        })();
      }
    );
  };
  const goToClients = () => {
    getCountDashboard();
  };
  const dateFromHandler = (e) => {
    SearchGridInputData[0].DateFrom = e;
    if (e)
      SearchGridInputData[0].DateFrom = dateFilter(
        SearchGridInputData[0].DateFrom
      );
    setDateFrom(SearchGridInputData[0].DateFrom);
  };
  const dateFilter = (date) => {
    return new Date(date.getTime());
  };
  const dateToHandler = (e) => {
    SearchGridInputData[0].DateTo = e;
    if (e)
      SearchGridInputData[0].DateTo = dateFilter(SearchGridInputData[0].DateTo);
    setDateTo(SearchGridInputData[0].DateTo);
  };
  const resetModal = () => {
    setiisExcelDownload(false);
    dateToHandler("");
    dateFromHandler("");
  }
  const downloadExportToExcel = (e) => {
    e?.preventDefault();
    setBoLoader(true);
    transactionObj.getAllCardsTransaction(
      Number(client),
      dateFrom || "0001-01-01",
      dateTo || "0001-01-01",
    ).then((resp) => {
      setBoLoader(false);
      if (resp?.data?.payload?.content?.length > 0) {
        setDataset(resp?.data?.payload?.content);
        setiisExcelDownload(true);
        setDateFrom("");
        setDateTo("");
        setClient("");
      }

    }).catch((err) => {
      setBoLoader(false);
    });

  }
  const ClientNameChangeHandler = (e) => {
    setClient(e.target.value)
  };

  const requiredClient = value => {
    if (!value) {
      document.getElementById("id_client").classList.add("has_error");
      setShowClientErr("");
      return false;
    } else {
      document.getElementById("id_client").classList.remove("has_error");
      setShowClientErr("d-none");
      return true;
    }
  };
 const onChangeIssuerCardBlances = (e) => {
    setBoLoader(true);
    clientmanagmentObj.issuerxcardbalance().then(
      (response) => {
        setShowIssuerBalances(true);
        setIssuerXCardBalances(response?.data?.payload ?? "N/A"); 
        setBoLoader(false);
      },
      (error) => {
        (async () => {
          let resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            window.location.reload();
            setBoLoader(false);
          } else {
            setBoLoader(false);
          }
        })();
      }
    );   

};
  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      <BoLoader loading={boloader} />
      {/* <h3>Statistics</h3> */}
      <div className="row mt-20">

        {haspermissions.CreateClient && (
          <Fragment>
            <div
              className="col-sm-6 col-md-3 col-xl-2"
              onClick={() => setCnfrmModalShow(true)}
            >
              <div className="col-stats col-stats-action mb-40 col-stats-mbl">
                <div data-bs-target="\clients" data-bs-toggle="modal">
                  <span className="icon-add-client">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                    <span className="path5"></span>
                    <span className="path6"></span>
                  </span>
                  {/* <img src={addclienticon} alt="addclient" /> */}
                  <br />
                  <Link to="#" className="pt-3">
                    Create Client
                    <span className="icon-bo-arrow"></span>
                    {/* <img src={cardArrow} alt="arrow" /> */}
                  </Link>
                </div>
              </div>
            </div>

          </Fragment>

        )}
        {haspermissions.LedgerTransfer && (
          <div
            className="col-md-3 col-sm-6 col-xl-2"
            onClick={() => setModalShowTransferClient(true)}
          >
            <div className="col-stats col-stats-action mb-40">
              <div>
                <span className="icon-load-card">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                  <span className="path11"></span>
                  <span className="path12"></span>
                  <span className="path13"></span>
                  <span className="path14"></span>
                </span>
                <br />
                <Link to="#" className="mt-3">
                  Ledger Transfer
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
        )}
        {
          <div
            className="col-md-3 col-sm-6 col-xl-2"
            onClick={() => setshowExcelDownloadModal(true)}
          >
            <div className="col-stats col-stats-action mb-40">
              <div>
                <span className="icon-load-card">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                  <span className="path11"></span>
                  <span className="path12"></span>
                  <span className="path13"></span>
                  <span className="path14"></span>
                </span>
                <br />
                <Link to="#" className="mt-3">
                  Card Transactions
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
        }
         {
          <div
            className="col-md-3 col-sm-6 col-xl-2"
            onClick={() => onChangeIssuerCardBlances()}
          >
            <div className="col-stats col-stats-action mb-40">
              <div>
                <span className="icon-load-card">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                  <span className="path5"></span>
                  <span className="path6"></span>
                  <span className="path7"></span>
                  <span className="path8"></span>
                  <span className="path9"></span>
                  <span className="path10"></span>
                  <span className="path11"></span>
                  <span className="path12"></span>
                  <span className="path13"></span>
                  <span className="path14"></span>
                </span>
                <br />
                <Link to="#" className="mt-3">
                  Issuer X Card Blances
                  <span className="icon-bo-arrow"></span>
                </Link>
              </div>
            </div>
          </div>
        }

      </div>
      {DataSuccessful && (
        <Fragment>
          <SearchGridClient
            methodname="getclients"
            placeholdervalue="Search Client"
            headersdata={[
              "LOGO",
              "CLIENT NAME",
              //"ADDRESS",
              "REG. DATE",
              //"CONTACT PERSON",
              "STATUS",
              "TOTAL BALANCE",
              // "CURRENCY",
              // "PROVIDER",
              // "VIEW",
            ]}
            apiurl={API_URL}
            screenname="clients"
            createclientpermission={haspermissions.CreateClient}
          />
        </Fragment>
      )}


      {haspermissions.CreateClient && (
        <AddSuperClient
          show={modelconfirmsuperclient}
          onHide={() => setModelconfirmsuperclient(false)}
          onAddClient={() => {
            setModelconfirmsuperclient(false);
            setModalsuccessfullShow(true);
          }}
        />
      )}

      {haspermissions.CreateClient && (
        <AddClient
          show={confirmmodalShow}
          onHide={() => setCnfrmModalShow(false)}
          onAddClient={() => {
            setCnfrmModalShow(false);
            setModalsuccessfullShow(true);
          }}
        />
      )}


      <TransferClient
        show={modalShowTransferClient}
        onHide={() => setModalShowTransferClient(false)}
      />
      <ModelPopup
        key={5}
        show={modalsuccessfullShow}
        onHide={() => setModalsuccessfullShow(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-42"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <div className="icon-alert icon-alert-popup">
                  <span className="icon-successful">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h2>Successful</h2>
                <div className="mt-16">
                  <div>
                    <form>
                      <div className="row">
                        <div className="col-md-12">
                          <p>Client Added Successfully</p>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group submit-field mt-40 mb-0">
                            <Link
                              to="#"
                              className="btn btn-large w-100"
                              onClick={() => {
                                setModalsuccessfullShow(false);
                                goToClients();
                              }}
                            >
                              Done
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
      <ModelPopup
        key={9999}
        show={showExcelDownloadModal}
        onHide={() => setshowExcelDownloadModal(false)}
        modelheading={""}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-52"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <h2></h2>
                <div className="">
                  <div>
                    {
                      isExcelDownload ? (
                        <>
                          <div className="row">
                            <div className="form-group">
                              <div className="col-md-6">
                                <ExportToExcel
                                  Dataset={dataset}
                                  Name="Allcardtransactions"
                                  calledfrom="Allcardtransactions"
                                />
                                 <button
                                    className="btn btn-large ms-lg-3"
                                    onClick={resetModal}
                                  >
                                    Reset
                                  </button>
                              </div>
                            </div>
                          </div>

                        </>
                      ) : (<form onSubmit={(e) => e.preventDefault()}>
                        <div className="row">
                          <div className="form-group">
                            <label>Select Client Ledger For Cards</label>
                            <div className="form-controls">
                              <GetAllClients
                                clientnamechangehandler={
                                  ClientNameChangeHandler
                                }
                                searchgriddata="Y"
                              />
                              <span
                                className={
                                  "help-block " + ShowClietErr
                                }
                              >
                                Client is required!
                              </span>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date From</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateFrom}
                                  onchangedate={dateFromHandler}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date To</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateTo}
                                  onchangedate={dateToHandler}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group submit-field d-flex justify-content-between mt-20 mb-0">

                              <button
                                className="btn btn-large"
                                onClick={downloadExportToExcel}
                              >
                                Done
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>)
                    }

                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
      <ModelPopup
        key={99999}
        show={showIssuerBalances}
        onHide={() => setShowIssuerBalances(false)}
        modelheading={"Issuer X Card Balance"}
        showheader={"false"}
        className="smallPopup issueCardSmall"
        dialogClassName="modal-dialog modal-dialog-centered mwidth-20"
        backdrop="static"
        keyboard={false}
        modelbody={[
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <h2></h2>
                <div className="">
                 <div className="form-group">
                    <label className="fw-bold fs-4">
  Issuer X Card Balance:
</label>
&nbsp;&nbsp;
<span className="fw-bold fs-3">
  $ {IssuerXCardBalances}
</span>

                  </div>
                </div>
              </div>
            </div>
          </Fragment>,
        ]}
      />
    </div>
  );
};

export default Clients;
